/** Frontend availability only; the backend must independently enforce this policy. */
export function isAudienceOrgAdmin(
  user: { orgId?: string; orgRole?: string; authType?: string } | null | undefined,
  org: { id?: string | null } | null | undefined,
): boolean {
  return Boolean(user && org?.id && user.orgId === org.id && user.orgRole === "admin" && user.authType !== "anonymous");
}

export function canManageAudiencePublication(
  user: { orgId?: string; orgRole?: string; authType?: string } | null | undefined,
  org: { id?: string | null } | null | undefined,
  resource: { orgId?: string; estateId?: string } | null | undefined,
  estates: Record<string, { orgId?: string }> = {},
): boolean {
  const ownerOrgId = resource?.estateId ? estates[resource.estateId]?.orgId : resource?.orgId;
  return isAudienceOrgAdmin(user, org) && Boolean(ownerOrgId && ownerOrgId === org?.id);
}
